import pt_BR from './pt-BR'
import en_US from './en-US'

export default {
  'pt-BR': pt_BR,
  'en-US': en_US,
}
